import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = ({
  newPageHeader,
}: { newPageHeader?: boolean } = {}) =>
  makeStyles(({ palette, custom, breakpoints }: Theme) => ({
    root: {
      backgroundColor: custom.pageHeader.backgroundColor,
      paddingTop: newPageHeader ? 20 : 25,
      paddingBottom: newPageHeader ? 70 : 43,
      ...(newPageHeader
        ? {
            [breakpoints.down(1024)]: {
              paddingTop: 5,
              paddingBottom: 51,
            },
            [breakpoints.down(500)]: {
              paddingBottom: 50,
            },
          }
        : {
            [breakpoints.down(640)]: {
              paddingBottom: 25,
            },
          }),
    },
    contentWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      maxWidth: custom.pageWidth,
      margin: 'auto',
      position: 'relative',
      paddingLeft: 20,
      paddingRight: 20,
      [breakpoints.down(newPageHeader ? 1024 : 640)]: {
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
      },
      ...(newPageHeader && {
        [breakpoints.down(500)]: {
          textAlign: 'left',
          alignItems: 'flex-start',
        },
      }),
    },
    title: {
      margin: 0,
      ...custom.pageHeader.title,
      ...(newPageHeader && {
        color: custom.grey[3],
        fontWeight: 900,
        lineHeight: '100%',
        '&>em': {
          color: palette.primary.main,
        },
        [breakpoints.down(1024)]: {
          lineHeight: '36px',
        },
        [breakpoints.down('xs')]: {
          fontSize: 32,
        },
      }),
    },
    titleSuffix: {
      color: palette.primary.main,
    },
    subTitle: {
      ...custom.pageHeader.subTitle,
    },
    secondTitle: {
      margin: 0,
      ...custom.pageHeader.secondTitle,
      ...(newPageHeader && {
        color: custom.grey[3],
        fontWeight: 400,
        paddingTop: 10,
        [breakpoints.down(1024)]: {
          fontSize: 16,
          lineHeight: '22px',
        },
        [breakpoints.down('xs')]: {
          fontSize: 16,
          lineHeight: '22px',
        },
        [breakpoints.down(500)]: {
          whiteSpace: 'pre-wrap',
        },
      }),
    },
    heading: {
      width: '100%',
      maxWidth: 700,
    },
    addon: {
      ...(newPageHeader
        ? {
            width: '100%',
          }
        : {
            marginLeft: 20,
            [breakpoints.down(640)]: {
              marginLeft: 0,
              paddingTop: 20,
            },
          }),
    },
  }));
